(function () {
  if (window.__arcticProductCardReceiptReady) return;
  window.__arcticProductCardReceiptReady = true;

  var SURFACE_SELECTOR = '[data-northbound-price-surface="card-receipt"]';
  var observer = null;
  var scheduled = false;

  function formatMoney(cents) {
    var normalized = Number.isFinite(cents) ? Math.round(cents) : 0;
    var runtime = window.__northboundStorefrontRuntime;
    var helpers = runtime && runtime.helpers;
    if (helpers && typeof helpers.formatMoney === 'function') {
      return helpers.formatMoney(normalized);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(normalized);
    }
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: 'CAD',
    }).format(normalized / 100);
  }

  function toCents(value) {
    var cents = Number(value);
    if (!Number.isFinite(cents)) return 0;
    return Math.max(0, Math.round(cents));
  }

  function setText(surface, selector, value) {
    var node = surface.querySelector(selector);
    if (node) node.textContent = value;
  }

  function clearSurface(surface) {
    setText(surface, '[data-card-receipt-shipping-before-subsidy]', '');
    setText(surface, '[data-card-receipt-subsidy-display]', '');

    var subsidyRow = surface.querySelector('.card__receipt-row--subsidy');
    if (subsidyRow) subsidyRow.hidden = true;
  }

  function applySurface(surface) {
    if (!surface) return;

    if (!surface.hasAttribute('data-northbound-shipping-cents')) {
      clearSurface(surface);
      return;
    }

    setText(surface, '[data-card-receipt-product-display]', formatMoney(toCents(surface.getAttribute('data-northbound-base-price-cents'))));
    var shippingCents = toCents(surface.getAttribute('data-northbound-shipping-cents'));
    var subsidyCents = toCents(surface.getAttribute('data-northbound-subsidy-cents'));
    var shippingBeforeSubsidyCents = shippingCents + subsidyCents;
    var subsidyRow = surface.querySelector('.card__receipt-row--subsidy');

    setText(
      surface,
      '[data-card-receipt-shipping-before-subsidy]',
      formatMoney(shippingBeforeSubsidyCents)
    );

    if (subsidyCents > 0) {
      setText(surface, '[data-card-receipt-subsidy-display]', '-' + formatMoney(subsidyCents));
      if (subsidyRow) subsidyRow.hidden = false;
    } else if (subsidyRow) {
      subsidyRow.hidden = true;
    }
  }

  function applyAll() {
    document.querySelectorAll(SURFACE_SELECTOR).forEach(applySurface);
  }

  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      applyAll();
    });
  }

  function watchSurfaces() {
    if (observer || !document.documentElement) return;

    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        var target = mutations[i].target;
        if (target instanceof Element && target.matches(SURFACE_SELECTOR)) {
          scheduleApply();
          return;
        }
      }
    });

    observer.observe(document.documentElement, {
      subtree: true,
      attributes: true,
      attributeFilter: [
        'data-northbound-base-price-cents',
        'data-northbound-shipping-cents',
        'data-northbound-subsidy-cents',
        'data-northbound-grand-total-cents',
      ],
    });
  }

  function init() {
    watchSurfaces();
    scheduleApply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('northbound:cart-pricing-applied', scheduleApply);
  window.addEventListener('northbound:community-changed', scheduleApply);
  window.addEventListener('northbound:variant-changed', scheduleApply);
  window.addEventListener('northbound:surfaces-changed', scheduleApply);
})();
